import { ElementRef, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import * as olProj from 'ol/proj';
import { ToastrService } from 'ngx-toastr';
import { Feature } from 'ol';
import { Point } from 'ol/geom';
import { Icon, Style } from 'ol/style';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Subject, takeUntil } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { environment } from 'src/environments/environment';
import { OtherService } from 'src/app/services/other.service';
import { AccountService } from 'src/app/services/account.service';
import { FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { MapService } from 'src/app/services/map.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AdsInfiniteScrollService } from '../business-main-infinite-scroll/service/ads-infinite-scroll.service';
import { GeolocationData, MapBuilderService } from 'src/app/services/map-builder.service';

declare var bootstrap: any;

@Component({
  selector: 'app-business',
  templateUrl: './business.component.html',
  styleUrls: ['./business.component.css']
})

export class BusinessComponent implements OnInit {
  map: any = {};
  htmlContent: any;
  popAds: any;
  Info: any;
  isResultLoading: boolean = false;
  isRequest: boolean = false;
  bShowResult: boolean = true;
  bShowMap: boolean = false;
  bShowFilter: boolean = false;
  bScrollLoading: boolean = false;
  bDataEnded: boolean = false;
  bUpButton: boolean = false;
  isDesktop: boolean = true;
  isMobile: boolean = false;
  isInitialize: boolean = true;
  bNearby: boolean = false;
  isLogin: boolean;
  isRequestingLocation: boolean = false;
  cancelRequest$ = new Subject();
  list_City: any = [];
  list_Category: any = [];
  list_SubCategory: any = [];
  list_Business: any = [];
  list_Tooltip: any = [];
  lst_Province: any = [];
  mapObj: any = {};
  tooltipLeft: number;
  tooltipTop: number;

  private destroy$ = new Subject<void>();

  searchModel: FormGroup = this.formBuilder.group({

    iTaxiLon_User: new FormControl(this.otherService.getLocalStorage()?.Id),

    strSession: new FormControl(this.otherService.getLocalStorage()?.session),

    strState: new FormControl(''),

    strCityCode: new FormControl(''),

    strSearchContent: new FormControl(''),

    bLiked: new FormControl(false),

    iResume_Category: new FormControl(-1),

    iResume_SubCategory: new FormControl(-1),

    fLat: new FormControl(-1),

    fLon: new FormControl(-1),

    iZoom: new FormControl(-1),

    iPage: new FormControl(-1),

    iTotal: new FormControl(0),

  });

  @ViewChild('itemsContainer') itemsContainer: ElementRef;
  @ViewChild('point_1', { static: false }) private my_point_1: ElementRef;

  constructor(
    private otherService: OtherService,
    private accountService: AccountService,
    private formBuilder: FormBuilder,
    private mapService: MapService,
    private router: Router,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private deviceService: DeviceDetectorService,
    private _InfiniteScrollService: AdsInfiniteScrollService,
    private _MapService: MapService,
    private mapBuilderService: MapBuilderService

  ) { }

  ngOnInit(): void {

    this.Info = this.otherService.getLocalStorage();
    this.isDesktop = this.deviceService.isDesktop();
    this.isMobile = this.deviceService.isMobile();
    this.otherService.setTitle(`امدادران | بانک اطلاعات تعمیرگاه و فروشگاه های قطعات خودرو`);
    this.otherService.isUserLogin$.subscribe((condition) => {

      this.isLogin = condition;

      if (condition) {

        this.searchModel.patchValue({

          strState: this.otherService.getLocalStorage().strState || '',

          strCityCode: this.otherService.getLocalStorage().CityCode || '',

        })

        if (this.otherService.getLocalStorage().strState != '') {

          this.getCity(this.otherService.getLocalStorage().strState, true)

        }

      }

      else {

        this.searchModel.patchValue({

          strState: '',

          strCityCode: '',

        })

      }

    });

    // look at the query

    this.route.queryParams.subscribe((query: any) => {

      this.searchModel.patchValue({

        iResume_Category: query.group || -1,

        iResume_SubCategory: query.subGroup || -1,

        strSearchContent: query.q || '',

        strState: query.state || '',

        strCityCode: query.city || '',

      })

      if (query?.map && this.isInitialize) {

        this.isInitialize = false;

        this.mapObj = query;

        this.bShowResult = false;

        this.bShowFilter = false;

        this.bShowMap = true;

        setTimeout(() => {

          // this.newOpenMap(8.6203076, -21.0426228);
          this.newOpenMap();

          this.map.on('click', (e: any) => {
            if (e.dragging) return;

            var el = this.mapService.mapPointerMove(
              this.map.getEventPixel(e.originalEvent),

              this.map
            );

            this.business_tooltip(e, el);
          });

          this.map.on('pointermove', (e: any) => {
            if (e.dragging) return (this.list_Tooltip = []);

            var el = this.mapService.mapPointerMove(
              this.map.getEventPixel(e.originalEvent),

              this.map
            );

            var pixel = this.map.getEventPixel(e.originalEvent);

            var hit = this.map.hasFeatureAtPixel(pixel);

            this.map.getViewport().style.cursor = hit ? 'pointer' : '';
          });

          if (this.mapObj?.lat && this.mapObj?.lon) {
            this.straight_OnMap({
              fLon: this.mapObj.lon,
              fLat: this.mapObj.lat,
            });
          }

          if (query?.nearby) {

            this.bNearby = true;

          }

        }, 500);

      }

      if (this.bShowMap || this.isMobile && this.isInitialize) {

        // if (!this.mapObj.lat && !this.mapObj.lon && this.isInitialize) {

        this.isInitialize = false;

        this.isResultLoading = true;

        this.sendLocationToApi(1, false, true);

      }

    });

    this.basic_information();

    // get city if state is in query

    if (this.searchModel.get('strState')?.value) {

      this.getCity(this.searchModel.get('strState')?.value, true)

    }

    // get subGroup if state is in query

    if (this.searchModel.get('iResume_SubCategory')?.value) {

      this.updateCategory(this.searchModel.get('iResume_Category')?.value, true)

    }

    // listen to user scroll activity

    this._InfiniteScrollService.isScrollToBottom$.subscribe(
      (isScrollBottom: boolean) => {
        if (
          isScrollBottom &&
          !this.bDataEnded &&
          this.list_Business.length &&
          !this.isResultLoading
        ) {
          this.loadMoreData();
        }
      }
    );

    // listen to data ended status per loading

    this._InfiniteScrollService.isDataEnded$.subscribe((isEnded: boolean) => {
      if (isEnded) {
        this.bScrollLoading = false;

        this.bDataEnded = true;
      }
    });

    // آبا کاربر شهری را تغییر داده است

    this.otherService.isUserSelectedCity$.subscribe((condition) => {

      let strCityCode = this.otherService.get_defaultCity().strCityCodeNew;

      // اگر کاربر شهری را انتخاب کرده باشد از هدر 

      if (condition && (strCityCode || strCityCode == '')) {

        this.searchModel.patchValue({

          // strCityCode: this.otherService.get_defaultCity()?.strCityCodeNew,

          iPage: -1,

          iTotal: 0,

        })

        this.bUpButton = false;

        this.sendLocationToApi(2, true, true)
      }

      else {

        // this.searchModel.controls['strCityCode'].setValue(this.otherService.basicModel().strCityCode);

      }

    });

  }

  ngOnDestroy() {
    this.otherService.setTitle('');

    this.destroy$.next();
    this.destroy$.complete();

  }

  openPopAds() {

    var model = {

      iTaxiLon_User: this.Info?.Id || 0,

      strSession: this.Info?.session || "",

      tiLocation: 2,

    };

    this.accountService.Dyar_PopupADV_Get(model).subscribe((data) => {

      let res = JSON.parse(data.toString());

      if (res?.length > 0) {

        var myModal = new bootstrap.Modal(document.getElementById('modal'), {});

        myModal.show();

        this.popAds = res[0];

      }

    });

  }

  popupClick(iDyar_PopupADV: number) {

    var model = {

      iTaxiLon_User: this.Info?.Id || 0,

      strSession: this.Info?.session || "",

      iDyar_PopupADV: iDyar_PopupADV,

    };

    ajax.post(environment.baseUrl + `Dyar_PopupADV_Click`, model,

      { 'Content-type': 'application/json' }

    ).subscribe({

      error(err) {

        this.accountService.toastSwal('error', 'وضعیت اتصال خود را بررسی کنید');

      },

    });

  }

  getSafeHtml(value: string): SafeHtml {

    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

  sendLocationToApi(iNumber: number, isReset?: boolean, isFirstCall?: boolean) {

    this.isResultLoading = true;

    if (this.bShowMap && !isFirstCall) {

      this.mapService.removeLayerByName('business-icon', this.map);

    }

    if (this.searchModel.get('iResume_Category')?.value == -1 && this.searchModel.get('iResume_SubCategory')?.value != -1) {

      this.searchModel.controls['iResume_SubCategory'].setValue(-1);

    }

    this.addQueryParam();

    if (isReset) {

      this.searchModel.get('iPage')?.setValue('-1');

      this._InfiniteScrollService.update_DataStatus(false);

      this.bDataEnded = false;

      this.list_Business = []; // new


    }

    if (this.bShowMap) {

      this.searchModel.get('iPage')?.setValue('-2');

    }

    ajax.post(environment.taxiUrl + `Resume_Search`, this.otherService.stringNumberToNumber(this.searchModel.value), {

      'Content-Type': 'application/json',
    }
    ).pipe(takeUntil(this.cancelRequest$)).subscribe({

      next: (value: any) => {

        // this.list_Business = []; // new

        this.isResultLoading = false;

        this.bScrollLoading = false;

        let res = JSON.parse(value.response);

        if (res.bError) {

          this.isResultLoading = false;

          this._InfiniteScrollService.update_DataStatus(true);

          return this.accountService.toastSwal('error', res.strError);

        }

        if (!res.length) {

          this.isResultLoading = false;

          this._InfiniteScrollService.update_DataStatus(true);

          this.list_Business = [];

          return this.accountService.toastSwal('error', 'موردی یافت نشد');

        }

        //  reset Value , Simulate scrolling Up

        if (!this.bShowMap && isReset) {
          this.list_Business = [];

          setTimeout(() => {
            this.list_Business = res;

            this.searchModel
              .get('iTotal')
              ?.setValue(this.list_Business[0].iTotal);
          }, 100);
        }

        if (this.bShowMap) {

          this.list_Business = res;

          this.searchModel.get('iTotal')?.setValue(this.list_Business[0].iTotal);

        }

        // if user is on viewMode ,concat value

        if (!this.bShowMap && !isReset) {
          this.list_Business = this.list_Business.concat(res);

          this.searchModel
            .get('iTotal')
            ?.setValue(this.list_Business[0].iTotal);
        }

        // if iPage of data is equal to 0,stop loading data

        if (res[res.length - 1].iPage == 0) {
          this._InfiniteScrollService.update_DataStatus(true);
        }

        if (!this.list_Business.length) return;

        if (this.bShowMap) {

          setTimeout(() => {

            this.list_Business.forEach((point: any) => {

              if (point.fLat !== 0 && point.fLon !== 0) {

                let iconSrc: string = '../../../assets/imgs/mapicon-32x32.png';

                const iconStyle = new Style({

                  image: new Icon({

                    src: iconSrc,

                    size: [40, 38],

                    anchor: [0.5, 1],

                  }),

                });

                const marker = new Feature({

                  geometry: new Point(

                    olProj.fromLonLat([point.fLon, point.fLat])

                  ),

                });

                marker.setStyle(iconStyle);

                const vectorSource = new VectorSource({ features: [marker] });

                var vectorLayer = new VectorLayer({

                  source: vectorSource,

                  name: 'business-icon',

                } as any);

                marker.set('business_data', point);

                this.map.addLayer(vectorLayer);
              }

            });

            if (this.list_Business[0]?.strTitle != res[0]?.strTitle || isFirstCall) {

              this.fitMap(this.list_Business);

            }

          }, 1000);

        }

      },

      error: (err) => {
        this.accountService.toastSwal(
          'error',
          'لطفا وضعیت اتصال اینترنت خود را بررسی کنید'
        );

        this.isResultLoading = false;

        this._InfiniteScrollService.update_DataStatus(true);
      },

    });
  }

  newOpenMap(...location) {
    this.map = this.mapBuilderService.createMap('test');
  }

  fitMap(dataArray?: any) {

    const coordinates = dataArray.map(item => {
      return [item.fLon, item.fLat];
    });

    this.mapBuilderService.fitMapToCoordinates(coordinates);

    if (this.bNearby) {
      this.getUserLocation();
      setTimeout(() => {
        this.bNearby = false;
      }, 600);
      return
    }

  }

  fitMap_2(location_Data) {

    let bZoomMap: boolean = true;

    if (!location_Data.length) return;

    let maxLatitude = -Infinity;

    let maxLongitude = -Infinity;

    let minLatitude = Infinity;

    let minLongitude = Infinity;

    for (const item of location_Data) {
      if (item.fLat !== 0 && item.fLon !== 0) {
        if (item.fLat > maxLatitude) maxLatitude = item.fLat;

        if (item.fLon > maxLongitude) maxLongitude = item.fLon;

        if (item.fLat < minLatitude) minLatitude = item.fLat;

        if (item.fLon < minLongitude) minLongitude = item.fLon;
      }

      if (location_Data.length == 1 && item.fLat == 0 && item.fLon == 0) {
        return (bZoomMap = false);
      }
    }

    if (bZoomMap) {
      var model = {
        maxLatitude: maxLatitude + 1,

        maxLongitude: maxLongitude + 1,

        minLatitude: minLatitude - 1,

        minLongitude: minLongitude - 1,
      };

      var view = this.map.getView();

      var transformedStart = this.mapService.transformCoordinates2([
        model.maxLongitude,

        model.maxLatitude,
      ]);

      var transformedEnd = this.mapService.transformCoordinates2([
        model.minLongitude,

        model.minLatitude,
      ]);

      var source = [
        Math.min(transformedStart[0], transformedEnd[0]) - 300,

        Math.min(transformedStart[1], transformedEnd[1]) - 300,

        Math.max(transformedStart[0], transformedEnd[0]) + 300,

        Math.max(transformedStart[1], transformedEnd[1]) + 300,
      ];

      view.fit(source);
    }

  }

  business_tooltip(e: any, element: any) {

    this.list_Tooltip = [];

    if (!element.featureLayer) return;

    var model = {

      iTaxiLon_User: this.otherService.getLocalStorage()?.Id,

      strSession: this.otherService.getLocalStorage()?.session,

      iTaxiLon_User_Citizen: element.featureLayer.feature.values_.business_data.iTaxiLon_User,

    };

    this.accountService.Resume_Info4UserFromMap(model).subscribe((data) => {
      let res = JSON.parse(data.toString());

      if (res.bError)
        this.list_Tooltip.push(
          element.featureLayer.feature.values_.business_data
        );

      if (!res.bError) this.list_Tooltip.push(res[0]);
    });

    const clientX = e.originalEvent.clientX;

    const clientY = e.originalEvent.clientY;

    const tooltipDiv = document.getElementById(
      'business-tooltip'
    ) as HTMLElement;

    const tooltipWidth = tooltipDiv.offsetWidth;

    const tooltipHeight = tooltipDiv.offsetHeight;

    this.tooltipLeft = clientX - tooltipWidth / 2;

    this.tooltipTop = clientY - tooltipHeight - 10;

    // Make sure the tooltip does not go off-screen on the left

    if (this.tooltipLeft < 0) this.tooltipLeft = 0;

    // Make sure the tooltip does not go off-screen on the top

    if (this.tooltipTop < 0) this.tooltipTop = 0;

    // Set the position of the tooltip

    tooltipDiv.style.left = this.tooltipLeft + 'px';

    tooltipDiv.style.top = this.tooltipTop + 'px';
  }

  basic_information() {

    if (this.accountService.list_StoredCategory.length != 0) {
      this.list_Category = this.accountService.list_StoredCategory;
    }

    if (this.accountService.list_StoredCategory.length == 0) {
      this.accountService.Dyar_BusinessGroupSearch().subscribe((data) => {
        let res = JSON.parse(data.toString());

        if (res.bError)
          return this.accountService.toastSwal(
            'error',
            res.strError + ' Business group'
          );

        this.list_Category = res;

        this.accountService.list_StoredCategory = res;
      });
    }

    this.accountService.GetState().subscribe((response) => {

      let res = JSON.parse(response.toString());

      this.lst_Province = res;

    });

  }

  updateCategory(iResume_Category, isInit: boolean = false) {

    if (!isInit) {

      this.searchModel.get('iResume_SubCategory')?.setValue(-1);
    }

    this.accountService.Dyar_BusinessSubgroupSearch(iResume_Category).subscribe((data) => {

      let res = JSON.parse(data.toString());

      if (res.bError) return this.accountService.toastSwal('error', res.strError + ' Business subGroup');

      this.list_SubCategory = res;

      if (this.bShowMap) this.mapService.removeLayerByName('business-icon', this.map);

      if (this.isDesktop) this.sendLocationToApi(3, true, true);

    });

  }

  updateSubCategory() {
    if (this.bShowMap)
      this.mapService.removeLayerByName('business-icon', this.map);

    if (this.isDesktop) this.sendLocationToApi(4, true, true);
  }

  straight_OnMap(data: any) {

    var view = this.map.getView();

    view.animate({
      zoom: 19,

      center: olProj.transform(
        [data.fLon, data.fLat],

        'EPSG:4326',

        'EPSG:3857'
      ),

      duration: 1000,
    });

    setTimeout(() => {
      var coordinates = olProj.transform(
        [data.fLon, data.fLat],

        'EPSG:4326',

        'EPSG:3857'
      );

      // Create a point feature

      var point = new Point(coordinates);

      var pointFeature = new Feature({
        geometry: point,
      });

      var iconStyle = new Style({
        image: new Icon({
          src: '../../../assets/imgs/mapicon-32x32.png', // Replace with the actual path to your custom icon

          size: [40, 38],

          anchor: [0.5, 1],
        }),
      });

      pointFeature.setStyle(iconStyle);

      var vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: [pointFeature],
        }),
      });

      this.map.addLayer(vectorLayer);

      var pix = this.map.getPixelFromCoordinate(coordinates);

      var el = this.mapService.mapPointerMove(
        [pix[0] + 18, pix[1] - 27.5],

        this.map
      );
    }, 1200);
  }

  show_OnMap(event: any, item: any) {

    event.stopPropagation();

    if (item.fLon == 0 || item.fLat == 0) return this.accountService.toastSwal('error', 'مشخصات مکان یافت نشد');

    const urlTree = this.router.createUrlTree(['/business'], {

      queryParams: { map: true, lat: item.fLat, lon: item.fLon },

    });

    const url = this.router.serializeUrl(urlTree);

    window.open(url, '_blank');

  }

  check_UserLogin() {
    if (!this.isLogin) {
      this.searchModel.get('bLiked')?.setValue(false);

      Swal.fire({
        title: 'ابتدا وارد حساب کاربری خود شوید',

        icon: 'warning',

        showCancelButton: true,

        showConfirmButton: true,

        confirmButtonText: 'ورود',

        cancelButtonText: 'بازگشت',

        confirmButtonColor: '#10B981',
      }).then((result) => {
        if (result.isConfirmed)
          return this.router.navigate([`/login/business`]);
      });
    } else {
      this.isResultLoading = true;

      this.sendLocationToApi(5);
    }
  }

  likeBusiness(event: any, item) {
    event.stopPropagation();

    if (!this.isLogin) {
      this.searchModel.get('bLiked')?.setValue(false);

      Swal.fire({
        title: 'ابتدا وارد حساب کاربری خود شوید',

        icon: 'warning',

        showCancelButton: true,

        showConfirmButton: true,

        confirmButtonText: 'ورود',

        cancelButtonText: 'بازگشت',

        confirmButtonColor: '#10B981',
      }).then((result) => {
        if (result.isConfirmed)
          return this.router.navigate([`/login/business`]);
      });
    } else {
      this.isResultLoading = true;

      ajax.post(
        environment.baseUrl + `Dyar_ResumeLike_SaveDelete`,

        {
          iResume_UserManager_User: item.iTaxiLon_User,
          ...this.searchModel.value,
        },
        { 'Content-type': 'application/json' }
      ).subscribe({
        next: (value: any) => {
          let res = JSON.parse(value.response);

          if (res.bError)
            return this.accountService.toastSwal('error', res.strError);

          const index = this.list_Business.findIndex(
            (x) => x.iTaxiLon_User === item.iTaxiLon_User
          );

          if (index != -1)
            this.list_Business[index].bLiked = item?.bLiked
              ? !item?.bLiked
              : true;

          this.isResultLoading = false;
        },

        error(err) {
          this.accountService.toastSwal(
            'error',
            'خطایی رخ داده است مجددا تلاش کنید'
          );

          this.isResultLoading = false;
        },
      });

    }

  }

  isLiked(item): boolean {
    const index = this.list_Business.findIndex(
      (x) => x.iTaxiLon_User === item.iTaxiLon_User
    );

    return this.list_Business[index]?.bLiked
      ? this.list_Business[index]?.bLiked
      : false;
  }

  open_Business(item) {

    // window.open(`business/${item.iTaxiLon_User}`,'_self');

    window.open(`business/${item.iTaxiLon_User}`, '_blank');

  }

  backTo(target: 'showMap' | 'showResults' | 'showFilter') {

    if (target === 'showMap' && !this.isResultLoading) {

      let model = this.searchModel.value;

      const urlTree = this.router.createUrlTree(['/business'], {

        queryParams: {

          map: true,

          group: model.iResume_Category != -1 ? model.iResume_Category : null,

          subGroup: model.iResume_SubCategory != -1 ? model.iResume_SubCategory : null,

          state: model.strState != '' ? model.strState : null,

          city: model.strCityCode != '' ? model.strCityCode : null,

          q: this.searchModel.get('strSearchContent')?.value || null,

        },

      });

      const url = this.router.serializeUrl(urlTree);

      window.open(url, '_blank');

      return

    }

    if (target === 'showResults') {
      this.bShowMap = false;

      this.bShowFilter = false;

      this.bShowResult = true;

      this.list_Tooltip = [];

      if (!this.isDesktop) {
        this.sendLocationToApi(6, true, true);
      }
    }

    if (target === 'showFilter' && !this.isResultLoading) {
      this.bShowMap = false;

      this.bShowResult = false;

      this.bShowFilter = true;
    }
  }

  // load more data per scroll

  loadMoreData() {
    if (this.list_Business.length == this.searchModel.get('iTotal')?.value) {
      this._InfiniteScrollService.update_DataStatus(true);
    } else {
      this.bScrollLoading = true;

      setTimeout(() => {
        // mapBusiness.classList.add('d-none')

        this.searchModel
          .get('iPage')
          ?.setValue(this.list_Business[this.list_Business.length - 1].iPage);

        this.sendLocationToApi(7);
      }, 600);
    }
  }

  // goUp button

  gotoTop() {

    this.my_point_1.nativeElement.scrollIntoView({

      behavior: 'smooth',

    });

    setTimeout(() => {

      // this._UpButtonServiceService.update_ButtonStatus(false)

    }, 1000);

  }

  getUserLocation() {
    this.isRequestingLocation = true;
    this.mapBuilderService.requestCurrentLocation$().pipe(takeUntil(this.destroy$)).subscribe({
      next: (location: GeolocationData) => {
        const coordinates: [number, number][] = [
          [location.longitude, location.latitude]
        ];
        this.mapBuilderService.fitMapToCoordinates(coordinates);
        this.isRequestingLocation = false;
      },
      error: (err) => {
        this.toastr.error('', err);
        this.isRequestingLocation = false;
      }

    });

  }

  getCity(sateCode, isInit: boolean = false) {

    if (!sateCode || sateCode == '' || sateCode == -1) {

      // this.searchModel.get('strCityCode')?.setValue('');

      // this.list_City = [];

      return;

    }

    this.accountService.GetCity(sateCode, this.otherService.stringNumberToNumber(this.searchModel.value)).subscribe((response: any) => {

      let res = JSON.parse(response.toString());

      if (res.bError) return this.accountService.toastSwal('error', res.strError + 'City');

      this.list_City = res;

      if (!isInit) this.searchModel.get('strCityCode')?.setValue('');

      if (this.bShowMap) {

        // this.searchModel.get('strCityCode')?.setValue('');

        // this.searchModel.get('strCityCode')?.setValue(this.mapObj.city || '');

      }


    });

  }

  addQueryParam() {

    let model = this.searchModel.value;

    this.router.navigate([], {

      relativeTo: this.route, queryParams: {

        group: model.iResume_Category == -1 ? null : model.iResume_Category,

        subGroup: model.iResume_SubCategory == -1 ? null : model.iResume_SubCategory,

        q: model.strSearchContent == '' ? null : model.strSearchContent,

        state: (model.strState == '' || model.strState == '-1') ? null : model.strState,

        city: (model.strCityCode == '' || model.strCityCode == '-1') ? null : model.strCityCode,

      },

      queryParamsHandling: 'merge', // پارامترهای قبلی حفظ شوند

    });

  }

}
